class WLSProductCards extends HTMLElement {
    constructor() {
        super();

        this.isMobile = window.innerWidth <= 1024;
        this.categoryBtns = this.querySelectorAll('.js-category');
        this.categoryWrapper = this.querySelector('.wls-product-cards__categories');
        this.productsLists = this.querySelectorAll('.js-products-list');

        this.classes = {
            activeClass: "active",
            sliderInitialized: "is-initialized",
        };

        this.slidesPerDevice = {
            mobile: 1,
            desktop: 4,
        };
    }

    connectedCallback() {
        this.setupTabs();
        this.initSlider(this.productsLists[0]);
    }

    setupTabs() {
        if (this.categoryBtns.length && this.productsLists.length) {
            this.categoryBtns.forEach((btn) => {
                btn.addEventListener("click", () => {
                    const { id } = btn.dataset;
                    this.switchActiveElements(id);
                    this.initSlider(this.getPanelById(id));
                    this.centerActiveTab(btn);
                });
            });
        }
    }

    switchActiveElements(id) {
        const activeElements = this.querySelectorAll(`.${this.classes.activeClass}`);
        const currentElements = this.querySelectorAll(`[data-id="${id}"]`);

        activeElements.forEach((el) => el.classList.remove(this.classes.activeClass));
        currentElements.forEach((el) => el.classList.add(this.classes.activeClass));
    }

    getPanelById(id) {
        return this.querySelector(
            `.js-products-list[data-id="${id}"]`,
        );
    }

    initSlider(slider) {
        if (!slider || slider.classList.contains(this.classes.sliderInitialized)) {
            return;
        }

        const slides = slider.querySelectorAll(".splide__slide");
        if (slides.length === 0) return;

        const sliderConfig = this.getSliderConfig(slides.length);
        new Splide(slider, sliderConfig).mount();
    }

    getSliderConfig(slidesLength) {
        const isMobile = this.isMobile;
        const { mobile, desktop } = this.slidesPerDevice;

        const shouldInitSlider =
            (isMobile && slidesLength > mobile) ||
            (!isMobile && slidesLength > desktop);

        const commonConfig = {
            perPage: isMobile ? mobile : desktop,
            perMove: isMobile ? mobile : desktop,
            pagination: true,
            gap: isMobile ? '16px' : '18px',

        };

        if (shouldInitSlider) {
            return {
                ...commonConfig,
                type: isMobile ? "loop" : "slide",
                arrows: true,
                drag: true,
            };
        }

        return {
            ...commonConfig,
            type: "slide",
            arrows: false,
            drag: false,
        };
    }

    centerActiveTab(tab) {
        const tabRect = tab.getBoundingClientRect();
        const containerRect = this.categoryWrapper.getBoundingClientRect();
        const offset = tabRect.left - containerRect.left + tabRect.width / 2;
        const scrollLeft =
            this.categoryWrapper.scrollLeft + offset - containerRect.width / 2;

        this.categoryWrapper.scrollTo({
            left: scrollLeft,
            behavior: "smooth",
        });
    }



}

if (!customElements.get('wls-product-cards')) {
    customElements.define('wls-product-cards', WLSProductCards);
}